import './App.css';

function App() {
  return (
    <>
      <a
        href="https://www.patreon.com/cw/CognistreamLab"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 1,
          cursor: "pointer"
        }}
      />

      <div className="App" style={{ position: "relative", zIndex: 2 }}>
        <header className="App-header">
          {/* Your content here */}
        </header>
      </div>
    </>
  );
}

export default App;
